// src/JitsiRoom.jsx
import React, { useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { toast } from "react-toastify";

const JitsiRoom = () => {
  const { roomName } = useParams();
  const jitsiRef = useRef(null);
  const { user } = useAuth();
  const navigate = useNavigate();
  const jitsiApiRef = useRef(null); // To hold the Jitsi API instance

  useEffect(() => {
    if (!roomName || typeof window.JitsiMeetExternalAPI === 'undefined' || !jitsiRef.current) {
      console.error("Jitsi prerequisites not met.");
      return;
    }

    const domain = "jitsi2.biz499.com";
    const options = {
      roomName,
      parentNode: jitsiRef.current,
      width: "100%",
      height: 500,
      userInfo: {
        displayName: `${user?.username || "Guest"} (${user?.role || "visitor"})`,
      },
      configOverwrite: {
        prejoinPageEnabled: false,
        startWithAudioMuted: true,
        disableInviteFunctions: true,
      },
      interfaceConfigOverwrite: {
        SHOW_JITSI_WATERMARK: false,
        SHOW_PROMOTIONAL_CLOSE_PAGE: false,
        TOOLBAR_BUTTONS: ['microphone', 'camera', 'chat', 'desktop', 'hangup'],
      },
    };

    const api = new window.JitsiMeetExternalAPI(domain, options);
    jitsiApiRef.current = api;

    let therapistId = null;

    // Event listener for when the conference is joined
    api.addEventListener('videoConferenceJoined', (response) => {
      // Find the therapist among participants
      const participants = api.getParticipantsInfo();
      const therapist = participants.find(p => p.displayName.includes('(therapist)'));
      if (therapist) {
        therapistId = therapist.participantId;
      }
    });

    // Event listener for when a participant leaves
    api.addEventListener('participantLeft', (response) => {
      // Check if the user is a client and the person who left was the therapist
      if (user?.role === 'client' && response.id === therapistId) {
        toast.info("The therapist has ended the session.");
        api.executeCommand('hangup');
      }
    });

    // Event listener for when the local user hangs up
    api.addEventListener('readyToClose', () => {
      // Redirect based on role after leaving the meeting
      if (user?.role === 'client') {
        navigate('/client/bookings');
      } else if (user?.role === 'therapist') {
        navigate('/expert/bookings');
      }
    });

    return () => {
      api?.dispose?.();
    };
  }, [roomName, user, navigate]);

  return <div ref={jitsiRef} className="mt-4 rounded shadow overflow-hidden" />;
};

export default JitsiRoom;